/* Excel Minimalista Landing */
(function () {
  'use strict';

  /* Hero background video — URLs from data attributes on #ltHeroVideo */
  var hv = document.getElementById('ltHeroVideo');
  if (hv) {
    var heroSrc = hv.getAttribute('data-video-src');
    var heroPoster = hv.getAttribute('data-poster-src');
    if (heroPoster) hv.setAttribute('poster', heroPoster);
    if (heroSrc) {
      var existing = hv.querySelector('source');
      if (existing) {
        existing.src = heroSrc;
      } else {
        var hs = document.createElement('source');
        hs.src = heroSrc;
        hs.type = 'video/mp4';
        hv.appendChild(hs);
      }
      hv.load();
    }
  }

  /* BEC panel video — from data attributes on #ltBec */
  var becBox = document.getElementById('ltBec');
  if (becBox) {
    var becSrc = becBox.getAttribute('data-video-src');
    var becPoster = becBox.getAttribute('data-poster-src');
    if (becSrc) {
      var empty = document.getElementById('ltBecEmpty');
      if (empty) empty.remove();
      var existingBv = becBox.querySelector('video');
      if (!existingBv) {
        var bv = document.createElement('video');
        bv.autoplay = true; bv.muted = true; bv.loop = true;
        bv.playsInline = true; bv.setAttribute('playsinline', '');
        bv.preload = 'metadata';
        if (becPoster) bv.poster = becPoster;
        var bs = document.createElement('source');
        bs.src = becSrc; bs.type = 'video/mp4';
        bv.appendChild(bs);
        becBox.insertBefore(bv, becBox.firstChild);
        bv.play().catch(function () {});
      } else {
        if (becPoster) existingBv.poster = becPoster;
        var es = existingBv.querySelector('source');
        if (es) { es.src = becSrc; existingBv.load(); }
        existingBv.play().catch(function () {});
      }
    }
  }

  /* Influencer YouTube cards — hydrate click-to-play if rendered by Liquid */
  document.querySelectorAll('.lt-vid[data-yt-id]').forEach(function (card) {
    if (card.dataset.bound) return;
    card.dataset.bound = '1';
    var open = function () {
      if (card.dataset.loaded) return;
      card.dataset.loaded = '1';
      var id = card.getAttribute('data-yt-id');
      var plain = card.getAttribute('data-yt-who') || '';
      var frame = card.querySelector('.lt-vid-frame');
      if (!frame || !id) return;
      frame.innerHTML =
        '<iframe src="https://www.youtube-nocookie.com/embed/' + id +
        '?autoplay=1&rel=0&modestbranding=1" title="Excel Hardware house tour with ' + plain +
        '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
    };
    card.addEventListener('click', open);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  });

  if ('IntersectionObserver' in window) {
    var o = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('lt-vis'); o.unobserve(e.target); }
      });
    }, { threshold: .08, rootMargin: '0px 0px -28px 0px' });
    document.querySelectorAll('.lt-reveal').forEach(function (el) { o.observe(el); });
  } else {
    document.querySelectorAll('.lt-reveal').forEach(function (el) { el.classList.add('lt-vis'); });
  }

  setTimeout(function () {
    document.querySelectorAll('.lt-hero .lt-reveal').forEach(function (el) { el.classList.add('lt-vis'); });
  }, 150);

  var v = document.getElementById('ltHeroVideo');
  if (v) {
    var show = function () { if (v.readyState >= 2) v.classList.add('lt-playing'); };
    v.addEventListener('loadeddata', show); v.addEventListener('canplay', show); show();
  }

  document.querySelectorAll('a[href^="#lt-"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    });
  });
})();
